<template>
  <div class="configurator_block">
    <Controls />
    <Map />
    <Canvas />
  </div>
</template>

<script>
import Canvas from '@/components/configurator/ConfiguratorCanvas.vue'
import Controls from '@/components/configurator/ConfiguratorControls.vue'
import Info from '@/components/configurator/ConfiguratorInfo.vue'
import Map from '@/components/configurator/ConfiguratorMap.vue'
import Tutorial from '@/components/configurator/ConfiguratorTutorial.vue'
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import scenarios from '../../assets/furnituresScenarios.json';

import {masterBus} from '@/main.js';
import { mapGetters } from 'vuex'

export default {
  name: 'Configurator',
  components:{Canvas,Controls,Info,Map,Tutorial},
  data(){
    return {
      configuratorTL : null
    }
  },
  computed: {
    ...mapGetters(['configuratorReady','appReady','currentScenario'])
  },
  beforeRouteEnter(to,from,next){
    if(from.name =="Home"){
      window.location.href = '/'+ to.params.lang + '/configurator/' + to.params.id;
    }
    else{
      next();
    }
  },
  beforeRouteLeave(to,from,next){
    masterBus.$off('startApp', this.showConfigurator);
    this.hideConfigurator(next);
  },
  mounted(){
    TweenMax.set('.app-content',{'background':'rgb(244, 244, 244)'});
    TweenMax.set('.configurator_app',{height:$(window).height()});
    masterBus.$on("startApp",this.showConfigurator);
    this.setCurrentScenario();
  },
  methods:{
    setCurrentScenario(){
      this.$store.dispatch('setCurrentScenario',scenarios.find(o => o.url === this.$route.params.id));
    },
    makeControlsReady(){
      masterBus.$emit("displayDropZones");
    },
    showConfigurator(){
      $('.logo_svg').removeClass("light");
      $('.header .back').removeClass("hidden");
      var configuratorTL = new TimelineMax({onComplete:this.makeControlsReady});
      configuratorTL.to(".configurator_block",1,{ease:Expo.easeOut,autoAlpha:1});
      var timeline = new TimelineMax();
      timeline.to(".configurator_app",2,{ease:Expo.easeOut,delay:.5,transform:"translateY(0px)",opacity:1})
              .to(".configurator_controls",1,{ease:Expo.easeOut,opacity:1},"-=.5");
    },
    hideConfigurator(callback){
      var configuratorTL = new TimelineMax({onComplete:callback});
      configuratorTL.to(".configurator_controls",.8,{ease:Expo.easeOut,opacity:0})
                    .to(".configurator_app",.8,{ease:Expo.easeOut,transform:"translateY(400px)",opacity:0},"-=.4");
    }
  }
}
</script>

<style lang="scss" >

.configurator_block{
  width: 100%;
  height: 100vh;
  background: #f4f4f4;
  position: relative;
  overflow: hidden;
  z-index: 1;
  opacity:0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  .configurator_intro{
    position: absolute;
    width: 100%;
    top: 10%;
    z-index: 100;
    text-align: center;
    .titles{
      width: 100%;
      position: relative;
      .start{
        opacity: 0;
        margin-top: 50px;
        padding: .7rem 3rem;
        font-size: 1rem;
        text-align: center;
        border:solid 1px rgba(0,0,0,0.1);
        background:rgb(20, 131, 1150);
        cursor: pointer;
        position: relative;
        color:white;
        border-radius: 400px;
        z-index: 100;
      }
      .label{
        opacity: 0;
      }
      .mainTitle{
        font-size: 2.9rem;
        transform: translateY(40px);
        opacity: 0;
      }

    }
  }

}

</style>
